var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body",style:({ height: _vm.styleHeight + 'px' })},[_c('div',{staticClass:"body-header"},[_c('span',{staticStyle:{"font-weight":"600","color":"#333333"}},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('el-empty',{staticClass:"empty-img",attrs:{"description":"暂无数据"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d16f13e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overview/components/EmptyData.vue
// module id = null
// module chunks = 